<template>
    <div class="admin-app">
        <top-bar/>
        <side-bar/>
        <router-view :key="$route.fullPath"/>
    </div>
</template>

<script>
import TopBar from "./TopBar.vue";
import SideBar from "./SideBar.vue";

export default {
    name: "MainApp",
    components: {SideBar, TopBar},
    mounted() {
        window.addEventListener('logout', () => {
            this.$router.go(0);
        });
        this.$api.get('/auth/user/info').then(response => {
            this.$store.commit('signin', response.data);
        });
    }
}
</script>

<style scoped>

</style>
